import { connect } from 'react-redux'
import type { RootState } from '@store/store'
import {
  getTimeline,
  timelineMarkersListSelector,
  timelineTimespansListSelector,
} from '@selectors/data/timeline_selectors.js'
import { getPhotos } from '@selectors/data/photo_selectors.js'
import HorizontalTimeline from '../components/HorizontalTimeline'

interface OwnProps {
  timelineId: string | number
  namespace?: string
}

const mapStateToProps = (state: RootState, props: OwnProps) => {
  const { timelineId } = props
  const timeline = getTimeline(state, { timelineId })
  const markers = timelineMarkersListSelector(state, props)
  const timespans = timelineTimespansListSelector(state, props)
  const photos = getPhotos(state)
  return { timeline, markers, timespans, photos }
}

export default connect(mapStateToProps)(HorizontalTimeline)
